const makeEconomy = (maxClaimedLand) => {
    let landPoints = 0;
    let advancementPoints = 0;
    let maxLandPoints = 0;
    let maxAdvancementPoints = 1;

    return {
        getLandPoints: () => landPoints,
        getAdvancementPoints: () => advancementPoints,
        useLandPoints: count => {
            landPoints -= count;
        },
        useAdvancementPoints: count => {
            advancementPoints -= count;
        },
        getMaxLandPoints: () => maxLandPoints,
        getMaxAdvancementPoints: () => maxAdvancementPoints,
        setLandPoints: (advancedClaimedCount, untouchedClaimedCount, resourceClaimedCount) => maxLandPoints = landPoints = Math.max(0, Math.min(advancedClaimedCount - untouchedClaimedCount, maxClaimedLand - advancedClaimedCount - untouchedClaimedCount - resourceClaimedCount)),
        updateMaxAdvancementPoints: untouchedClaimedCount => maxAdvancementPoints = untouchedClaimedCount < 4 ? 1 : Math.floor(untouchedClaimedCount/10) + 2,
        gainAdvancementPoint: () => advancementPoints = Math.min(maxAdvancementPoints, advancementPoints + 1)
    };
};

export default makeEconomy